import { MessageSquare } from 'lucide-react';

interface IconProps {
  className?: string;
  size?: number;
  strokeWidth?: number;
}

export function MessageSquareIcon({ className = '', size = 24, strokeWidth = 1.5 }: IconProps) {
  return (
    <MessageSquare
      width={size}
      height={size}
      strokeWidth={strokeWidth}
      className={className}
    />
  );
}
